var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 5.8a4.4 4.4 0 1 1-8.8 0 4.4 4.4 0 0 1 8.8 0ZM9.25 9.956a5.4 5.4 0 1 1 .707-.707l3.398 3.398a.5.5 0 1 1-.707.707L9.249 9.956ZM3.2 5.801a.5.5 0 0 1 .5-.5h1.6V3.7a.5.5 0 1 1 1 0v1.6h1.6a.5.5 0 0 1 0 1H6.3v1.6a.5.5 0 0 1-1 0V6.3H3.7a.5.5 0 0 1-.5-.5Z",
    fill: "#362B24"
  })));
};
export default SvgMagnifyingGlass;